//Timer Logic
function Scrolldown() {
  if($(document).width() > 767){
     window.scroll(0,100); 
  }
};

window.onload = Scrolldown;

const second = 1000,
minute = second * 60,
hour = minute * 60,
day = hour * 24;

let countDown = new Date("Apr 24, 2026 11:00:00").getTime()+(28800000 - (new Date().getTimezoneOffset()*60000)),
x = setInterval(function() {    
  let now = new Date().getTime(),

  distance = countDown - now;

  document.getElementById('days').innerText = Math.floor(distance / (day)),
  document.getElementById('hours').innerText = Math.floor((distance % (day)) / (hour)),
  document.getElementById('minutes').innerText = Math.floor((distance % (hour)) / (minute)),
  document.getElementById('seconds').innerText = Math.floor((distance % (minute)) / (second));
  
  const hours   = parseInt(document.getElementById("hours").innerText, 10);
  const minutes = parseInt(document.getElementById("minutes").innerText, 10);
  const seconds = parseInt(document.getElementById("seconds").innerText, 10);
  
  if (hours === 0 && minutes === 3 && seconds === 0) {
     window.location.reload(); 
   };
  
  // Timeout redirect, comment out after launch
  if (seconds < 0) {
     window.location.replace("https://tamedpsychotic.com/");
   };

}, second);